const AppointmentsCalendarState = {
  data: []
}

export default AppointmentsCalendarState
